<template>
  <q-card
    flat
    class="q-pa-sm full-width no-padding-md"
    style="max-width: 100vw"
  >
    <q-card-section class="row q-pb-xs text-green-vito justify-between">
      <div class="text-h5">
        {{ $t("title.messageLogs") }}
      </div>
      <div class="q-gutter-x-md row" style="height: 40px">
        <!--q-input
          outlined
          dense
          clearable
          debounce="300"
          v-model="filter"
          style="width: 120px"
          :placeholder="$t('label.search')"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input-->
      </div>
    </q-card-section>

    <q-card-section>
      <q-table
        class="sticky-header-table size-lg"
        dense
        flat
        bordered
        :rows="rows"
        separator="cell"
        :columns="columnsI18n"
        :loading="loading"
        row-key="index"
        virtual-scroll
        :virtual-scroll-item-size="28"
        :virtual-scroll-sticky-size-start="28"
        :pagination="pagination"
        :rows-per-page-options="[0]"
        @virtual-scroll="onScroll"
        ref="scroll-table"
      >
        <template v-slot:body-cell-date="props">
          <q-td :props="props">
            {{ $moment(props.value).format("DD/MM/YYYY HH:mm:ss") }}
          </q-td>
        </template>

        <template v-slot:body-cell-log="props">
          <q-td :props="props" auto-width>
            <div class="ellipsis" style="max-width: 350px">
              {{ props.value }}
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-contact="props">
          <q-td :props="props" auto-width>
            <div class="ellipsis" style="max-width: 350px">
              {{ contactValue(props) }}
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-type="props">
          <q-td :props="props">
            <q-chip
              square
              text-color="green-vito"
              :icon="typeIcon(props.value)"
            >
              {{ typeValue(props.value) }}
            </q-chip>
          </q-td>
        </template>

        <template v-slot:body-cell-status="props">
          <q-td :props="props">
            <q-badge :color="props.value == 0 ? 'green-vito' : 'red-vito'">
              {{
                props.value == 0 ? $t("status.success") : $t("status.failure")
              }}
            </q-badge>
          </q-td>
        </template>

        <template v-slot:body-cell-actions="props">
          <q-td :props="props">
            <q-btn
              icon="mail"
              round
              dense
              @click="
                selectedMessage = props.row;
                showLogCard = true;
              "
            >
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </q-card-section>
  </q-card>

  <q-dialog v-model="showLogCard" ref="ShowMessageDialog">
    <q-card
      bordered
      class="q-mt-md q-pa-md shadow-1"
      style="width: 550px; max-width: 90vw"
    >
      <q-card-section class="row text-green-vito no-wrap justify-between">
        <div class="text-h6">
          {{ $t("title.message") }} #{{ selectedMessage.id }}
        </div>
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>

      <q-card-section class="col-12 col-sm-auto">
        <message :message="selectedMessage"></message>
      </q-card-section>
      <q-card-section>
        <q-input v-model="prettyLog" filled type="textarea" autogrow readonly />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import MessageApi from "../../apis/Message";
import { ReversedMessageType, MessageType } from "../message/message.enum";
import Message from "../message/Message.vue";

export default {
  props: ["locker"],
  components: { Message },
  data: () => {
    return {
      selectedMessage: { log: "" },
      showLogCard: false,
      filter: null,

      loading: false,
      pagination: {
        rowsPerPage: 0,
      },
      rows: [],

      sortBy: "id",
      descending: true,
      pageSize: 50,
      nextPage: 1,
      lastPage: 1000,
    };
  },

  async mounted() {
    //
  },

  methods: {
    async onScroll({ to, index }) {
      //console.log(to, index);
      //const lastIndex = this.rows.length - 1;
      const startRow = (this.nextPage - 1) * this.pageSize;

      try {
        if (
          this.loading !== true &&
          this.nextPage <= this.lastPage &&
          (to === index || to === -1)
        ) {
          this.loading = true;
          const pageReponse = await MessageApi.paginate({
            startRow,
            fetchCount: this.pageSize,
            filter: null,
            sortBy: this.sortBy,
            descending: this.descending,
          });
          this.lastPage = Math.ceil(pageReponse.data.count / this.pageSize);

          pageReponse.data.items.forEach((row, index) => {
            row.index = this.rows.length + index;
          });
          this.rows = this.rows.concat(pageReponse.data.items);

          this.nextPage++;
          this.loading = false;
        }
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        this.errorMessage = message;
        this.$q.notify({
          type: "negative",
          message: message,
        });
      }
    },

    typeIcon(type) {
      return ReversedMessageType[type]
        ? MessageType[ReversedMessageType[type]].icon
        : "question_mark";
    },

    typeValue(type) {
      return this.$t("type.message." + ReversedMessageType[type]);
    },
    contactValue(props) {
      return props.row.type == MessageType.ORDER_SMS.value
        ? props.row.contactPhone
        : props.row.contactEmail;
    },
  },
  computed: {
    prettyLog() {
      //console.log(this.selectedLog);

      if (this.selectedMessage && this.selectedMessage.log) {
        try {
          const obj = JSON.parse(this.selectedMessage.log);
          const text = JSON.stringify(obj, null, 4);
          return text;
        } catch (error) {
          return this.selectedMessage.log;
        }
      }
      return "";
    },
    columnsI18n() {
      const columns = [
        {
          name: "id",
          required: true,
          label: "ID",
          align: "center",
          field: "id",
          sortable: true,
        },
        {
          name: "date",
          align: "center",
          label: this.$t("label.date"),
          field: "date",
          sortable: true,
        },
        {
          name: "status",
          label: this.$t("label.status"),
          field: "status",
          align: "center",
          sortable: true,
        },
        {
          name: "type",
          align: "center",
          label: this.$t("label.type"),
          field: "type",
          sortable: true,
        },
        {
          name: "contact",
          align: "center",
          label: this.$t("label.to"),
          sortable: true,
        },
        {
          name: "log",
          label: this.$t("label.log"),
          field: "log",
          align: "center",
          sortable: true,
        },
        { name: "actions", style: "width:70px" },
      ];

      return columns;
    },
  },
};
</script>
